<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card class="p-4 mb-6">
                <div class="vx-row mt-6">
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Current Password*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="old_password" type="password"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                New Password*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="password_1" type="password"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Retype New Password*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="password_2" type="password"/>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" icon="save">Save</vs-button>
            </vs-card>
        </div>
    </div>
</template>

<script>
	export default {
		data(){
			return {
                password_1: '',
                password_2: '',
                old_password: '',
                isLoading: false,
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            submitForm() {
                this.isLoading = true;
                this.$http.post('changepassword', {
                    current: this.old_password,
                    new: this.password_1,
                    confirm: this.password_2
                })
                .then(res => {
                    location.reload();
                })
                .catch(error => this.handleError(error));
            },
        },
	}
</script>